import requset from '@/utils/request.js'

const loginApi = {
  // 登录
  loginRequst(params){
    return requset({
      url: '/user/login',
      method: 'post',
      data: params
    })
  },
  // 统一认证登录
  loginFromAsiaRequest(params){
    return requset({
      url: '/user/loginFromAsia',
      method: 'post',
      data: params
    })
  },
  // 设研云统一认证登录
  loginFromSyyRequest(params){
    return requset({
      url: '/user/loginFromSyy',
      method: 'post',
      data: params
    })
  },
} 
export default loginApi;